/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_ToInputs */



/**
* | output |
* | --- |
* | "Apply to" |
*
* @param {Apply_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to = /** @type {((inputs?: Apply_ToInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_ToInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer à")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anwenden auf")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica a")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить к")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar a")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用于")
	if (locale === "ja") return /** @type {LocalizedString} */ ("適用対象")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar a")
	return /** @type {LocalizedString} */ ("Apply to")
});